import { QueryEntity } from '@datorama/akita';
import { Content } from '../../squidex';
import { IBaseState } from './base.state';
import { BaseStore } from './base.store';
import { FilterPagination } from './filter.pagination';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import internal from 'node:stream';

export abstract class BaseQuery extends QueryEntity<IBaseState, Content> {

  protected constructor(protected store: BaseStore) {
    super(store);
  }

  getPaginateData(filter: FilterPagination): Observable<Content[]> {
    const index = this.getValue().storedIndex;
    const contents = [];

    return this.selectAll()
      .pipe(map(entities => {
        for (let i = filter.from; i < filter.to; i++) {
          if (entities.some(content => content.id === index[i])) {
            contents.push(entities.find(content => content.id === index[i]));
          }
        }
        return contents;
      }));
  }

}
